import React, { useLayoutEffect } from "react";
import Loadable from "react-loadable";
import { Route, Switch, useLocation } from "react-router-dom";
import { AppConfig } from "./AppConfig";

export interface ParentAppProps {
  config: AppConfig;
}

declare global {
  interface Window {
    dataLayer: Array<unknown>;

    ga: Function;

    // eslint-disable-next-line camelcase
    gtag_report_conversion: (url?: string) => boolean;

    // eslint-disable-next-line camelcase
    bing_report_conversion: () => boolean;

    CallTrk: {
      swap: () => null;
    };

    Trustpilot: {
      loadFromElement: any;
    };
  }
}
if (typeof window !== "undefined") {
  window.dataLayer = window.dataLayer || {};
}

const RedirectToScreener = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    const redirectURL = location.pathname.startsWith(
      "/disability-benefits/n/get-help/start",
    )
      ? null
      : `/disability-benefits/n/get-help/start${location.search}`;

    if (redirectURL) {
      window.location.href = redirectURL;
    }
  }, []);

  return null;
};

const LoadablePortalApp = Loadable({
  loader: () => import(/* webpackChunkName: "portal" */ "./portal/PortalApp"),
  loading: () => null,
  modules: ["./portal/PortalApp"],
  webpack: () => [require.resolveWeak("./portal/PortalApp")],
});

export default function ParentApp({ config }: ParentAppProps) {
  return (
    <Switch>
      <Route
        path={`${config.appPath}/survey`}
        render={() => <RedirectToScreener />}
      />
      <Route
        path={`${config.portalAppPath}`}
        render={() => <LoadablePortalApp config={config} />}
      />
      <Route path="*" render={() => <RedirectToScreener />} />
    </Switch>
  );
}
